import React, { useRef } from 'react';
import './index.scss';
import { Button, Upload, message } from 'antd';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';

export interface UploadFileProps {
  onSuccessCallbak?: AnyFunc; // 文件上传成功回调
  max: string; // 文件大小限制，单位M
  maxCount?: number; // 最大上传文件数量
  accept?: string; // 接受上传的文件类型
  method: string; // 上传请求的method
  vehicleName?: string; // 车号
}
const UploadFile = (props: UploadFileProps) => {
  const beforUpload = (file: any) => {
    const fileSize = file.size / 1024 / 1024 < 100;
    if (!fileSize) {
      message.warning('文件大小不能超过100MB');
    }

    return fileSize || Upload.LIST_IGNORE;
  };
  return (
    <div className='upload-container'>
      <Upload
        name='file'
        beforeUpload={beforUpload}
        customRequest={async (option: any) => {
          const {
            action,
            data,
            file,
            filename,
            headers,
            onError,
            onProgress,
            onSuccess,
            withCredentials,
          } = option;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = async () => {
            request({
              path: '/monitor/web/s3/webTerminal/preSignGetAndPutUrl',
              method: Method.POST,
              body: {
                fileName: file.name,
                vehicleName: props.vehicleName,
              },
            }).then((res: any) => {
              const { fileName, getUrl, putUrl } = res.data;
              request({
                absoluteURL: putUrl,
                contentType: 'multipart/form-data',
                method: 'PUT',
                body: file,
                timeout: 60000,
              }).then((res) => {
                onSuccess(res, file);
                props.onSuccessCallbak &&
                  props.onSuccessCallbak({
                    fileName,
                    getUrl,
                  });
              });
            });
          };
        }}
      >
        <Button type='primary'>选择文件</Button>
        <i className='tips'>只支持100MB以内文件</i>
      </Upload>
    </div>
  );
};

export default React.memo(UploadFile);
